import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3debd896"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "filter-box" }
const _hoisted_2 = { class: "active-filters-content" }
const _hoisted_3 = { class: "main-filter-area" }
const _hoisted_4 = {
  key: 0,
  class: "filter-area-header"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Actieve Filters", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "filter-area-columns" }
const _hoisted_8 = {
  key: 0,
  class: "filter-message"
}
const _hoisted_9 = { class: "filter-header" }
const _hoisted_10 = { class: "stack" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-area-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Voorinstellingen")
], -1))
const _hoisted_12 = { class: "preset-items" }
const _hoisted_13 = {
  key: 0,
  class: "wo-red warning"
}

import { ls } from '@/ls'
import Column, { ColumnFilterItem } from '@/types/column'
import { UndoOutlined, SaveOutlined, DeleteOutlined } from '@ant-design/icons-vue'
import { watch, ref, onMounted, computed } from 'vue'
import axios from 'axios'

interface FilterPreset {
  name: string
  filters: {[key: string]:(string|number)[]}
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterBox',
  props: {
    activeFilters: null,
    columns: null,
    view: null
  },
  emits: ['update'],
  setup(__props: any, { emit }) {

const props = __props as { activeFilters: {[key: string]:(string|number)[]}|null, columns: Column[], view: string };




const activeFilters = ref<{[key: string]:(string|number)[]}>({})
const newPresetName = ref<string|null>(null)
const selectedPreset = ref({ name: '', filters: {} } as FilterPreset)
const presetInput = ref<HTMLInputElement|null>(null)
const modalVisible = ref<boolean>(false)
const presetExists = ref(false)

let presets: FilterPreset[] = []

const hasActiveFilters = computed(() => {
  return Object.keys(activeFilters.value).length > 0
})

const hasActivePreset = computed(() => {
  return selectedPreset.value.name !== ''
})

const collapseKey = computed(() => {
  const storedCollapseKey = ls.get(props.view + 'Filters')
  return storedCollapseKey || ['filters']
})

watch(() => props.activeFilters, () => {
  activeFilters.value = props.activeFilters || {}
  updateSelectedPreset(activeFilters.value)
}, { deep: true })

watch(() => modalVisible.value, () => {
  if (modalVisible.value) {
    setTimeout(() => {
      // eslint-disable-next-line no-unused-expressions
      presetInput.value?.focus()
    }, 100)
  }
})

onMounted(() => {
  getPresets()
  getActivePreset()

  activeFilters.value = props.activeFilters || {}
})

const getPresets = () => {
  const storedPresets: FilterPreset[] = ls.get(props.view + 'Presets') || []
  if (storedPresets) {
    presets = storedPresets
  }
}

const showModal = () => {
  modalVisible.value = true
}

const updateSelectedPreset = (filters: {[key: string]:(string|number)[]}) => {
  const preset = presets.find((preset) => JSON.stringify(preset.filters) === JSON.stringify(filters))
  setActivePreset(preset !== undefined ? preset : null)
}

const getActivePreset = () => {
  const storedActivePreset = ls.get(props.view + 'ActivePreset')
  if (storedActivePreset) {
    setActivePreset(storedActivePreset, true)
  }
}

const setActivePreset = (preset: FilterPreset|null, loadPreset = false) => {
  if (preset === null) {
    selectedPreset.value = { name: '', filters: {} }
    ls.remove(props.view + 'ActivePreset')
  } else {
    selectedPreset.value = preset
    ls.set(props.view + 'ActivePreset', preset)
  }

  if (loadPreset && preset) {
    emit('update', preset.filters)
  }
}

const addPreset = () => {
  if (newPresetName.value) {
    const newPreset: FilterPreset = {
      name: capitalize(newPresetName.value),
      filters: props.activeFilters || {}
    }
    presets.push(newPreset)
    setActivePreset(newPreset)

    storeActivePreset()
    storePresets()
  }

  modalVisible.value = false
  newPresetName.value = null
}

const storeActivePreset = () => {
  ls.set(props.view + 'ActivePreset', selectedPreset.value)
  axios.post(process.env.VUE_APP_API_URL + '/users/constructionSiteApp/settings', {
    settingName: props.view + 'ActivePreset',
    settingValue: selectedPreset.value
  })
}

const storePresets = () => {
  ls.set(props.view + 'Presets', presets)
  axios.post(process.env.VUE_APP_API_URL + '/users/constructionSiteApp/settings', {
    settingName: props.view + 'Presets',
    settingValue: presets
  })
}

const capitalize = (s: string|null) => {
  if (!s) return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

const getPrettyColumnName = (key: string) => {
  return props.columns.find((column) => column.key === key)?.title || key
}

const findFilterText = (filters: ColumnFilterItem[], value: string|number|boolean): string|number|boolean => {
  for (const filterItem of filters) {
    if (filterItem.value === value) return filterItem.text

    if (filterItem.children) {
      const childValue = findFilterText(filterItem.children, value)
      if (childValue !== '') return childValue
    }
  }

  return ''
}

const getFilterName = (index: string, value: string|number|boolean) => {
  let filteredValue: (string|number|boolean) = ''
  props.columns.forEach((column) => {
    if (column.filters && Array.isArray(column.filters) && column.key === index) {
      filteredValue = findFilterText(column.filters, value)
    }
  })

  return filteredValue
}

const cancelPreset = () => {
  newPresetName.value = null
  modalVisible.value = false
}

const deletePreset = (index: number) => {
  if (selectedPreset.value && selectedPreset.value.name === presets[index].name) {
    setActivePreset(null)
  }

  presets.splice(index, 1)

  storeActivePreset()
  storePresets()
}

const applyPreset = (preset: FilterPreset) => {
  selectedPreset.value = preset

  storeActivePreset()
  storePresets()

  emit('update', preset.filters)
}

const removeFilter = (key: string, value: string|number) => {
  const filters = activeFilters.value
  if (filters[key].length === 1) {
    delete filters[key]
  } else {
    filters[key].splice(filters[key].indexOf(value), 1)
  }

  emit('update', filters)
}

const removeAllFilters = () => {
  activeFilters.value = {}
  clearActivePreset()
  emit('update', activeFilters.value)
}

const clearActivePreset = () => {
  ls.remove(props.view + 'ActivePreset')
  selectedPreset.value = { name: '', filters: {} }
}

const activeKeyChanged = (key: string | string[]) => {
  ls.set(props.view + 'Filters', key)
}

const checkIfPresetExists = () => {
  if (newPresetName.value !== null) {
    presetExists.value = presets.some((preset) => preset.name.toLowerCase() === newPresetName.value?.toLowerCase())
  }
}


return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_collapse, {
      "default-active-key": _unref(collapseKey),
      onChange: activeKeyChanged
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_collapse_panel, {
          key: "filters",
          header: `Filters (${selectedPreset.value.name !== '' ? selectedPreset.value.name : _unref(hasActiveFilters) ? 'Niet opgeslagen' : 'Geen filters actief'})`,
          style: {"border":"none"}
        }, {
          extra: _withCtx(() => [
            _createElementVNode("div", {
              class: "filters-controls",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createVNode(_component_a_tooltip, {
                "mouse-enter-delay": .6,
                placement: "top",
                title: "Reset filters."
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    size: "small",
                    disabled: !_unref(hasActiveFilters),
                    onClick: removeAllFilters
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_unref(UndoOutlined))
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_tooltip, {
                "mouse-enter-delay": .6,
                placement: "left",
                title: !_unref(hasActivePreset)  ? 'Voorinstelling opslaan' : ''
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    size: "small",
                    disabled: !_unref(hasActiveFilters) || _unref(hasActivePreset),
                    onClick: showModal
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_unref(SaveOutlined))
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["title"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_col, {
                  class: "filter-area",
                  flex: 4
                }, {
                  default: _withCtx(() => [
                    (_unref(hasActiveFilters))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                      (!_unref(hasActiveFilters))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Geen filters of voorinstelling actief. "))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeFilters.value, (values, name, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "filter-column",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(getPrettyColumnName(name)), 1),
                          _createElementVNode("ul", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values, (value) => {
                              return (_openBlock(), _createElementBlock("li", { key: value }, [
                                _createVNode(_component_a_tag, {
                                  closable: true,
                                  onClose: ($event: any) => (removeFilter(name, value))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(getFilterName(name, value)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClose"])
                              ]))
                            }), 128))
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  flex: '240px',
                  class: "preset-selection-box"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _createElementVNode("ul", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(presets), (preset, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: index,
                          class: "preset-item"
                        }, [
                          _createVNode(_component_a_tooltip, {
                            "mouse-enter-delay": .6,
                            placement: "left",
                            title: "Laad deze voorinstelling."
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_tag, {
                                closable: false,
                                class: _normalizeClass({ active: selectedPreset.value.name === preset.name }),
                                onClick: _withModifiers(($event: any) => (applyPreset(preset)), ["prevent"])
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(preset.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["class", "onClick"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_a_tooltip, {
                            "mouse-enter-delay": .6,
                            placement: "left",
                            title: "Verwijder voorinstelling."
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_popconfirm, {
                                placement: "left",
                                title: "Weet je zeker dat je deze voorinstelling wilt verwijderen?",
                                "ok-text": "Ja",
                                "cancel-text": "Nee",
                                onConfirm: ($event: any) => (deletePreset(index))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, { size: "small" }, {
                                    icon: _withCtx(() => [
                                      _createVNode(_unref(DeleteOutlined))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onConfirm"])
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["default-active-key"]),
    _createVNode(_component_a_modal, {
      visible: modalVisible.value,
      title: "Voorinstelling opslaan",
      onOk: addPreset,
      onCancel: cancelPreset,
      inert: "",
      "ok-button-props": { disabled: !newPresetName.value || presetExists.value }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          value: newPresetName.value,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((newPresetName).value = $event)),
          ref_key: "presetInput",
          ref: presetInput,
          placeholder: "Naam voorinstelling",
          class: _normalizeClass({'wo-red-border': presetExists.value}),
          onChange: checkIfPresetExists,
          onKeyup: _withKeys(addPreset, ["enter"])
        }, null, 8, ["value", "class", "onKeyup"]),
        (presetExists.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Deze voorinstelling bestaat al!"))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "ok-button-props"])
  ]))
}
}

})